<div class="vota-layout min-h-screen flex flex-col">
  <vota-header></vota-header>
  <mat-sidenav-container class="flex-1 !bg-gray-100 dark:!bg-black-600">
    <mat-sidenav
      #drawer
      mode="over"
      position="end"
      [opened]="appStateService.isSidebarOpen()"
      [fixedInViewport]="true"
      [fixedTopGap]="67"
      class="!w-[310px] bg-white dark:bg-black-600 !rounded-none !py-[25px] page-sidebar border-l border-transparent dark:border-white/30"
    >
      <vota-sidebar></vota-sidebar>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="mt-[67px] min-h-[calc(100vh-67px)]">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
